import { ObjectIds } from "../../../../models/SupplierPortal"
import { getDoneIcon, getEmptyIcon } from "../../../../utils/getBooleanFlagIcon"
import {
  dateStringComparator,
  getNiceFormattedDate,
} from "../../../../utils/getFormattedDate"
import { EntityRow, EntityTab } from "../../../partials/EntityTab"

export function ObjectIdsDetails(props: { readonly objectIds: ObjectIds[] }) {
  const { objectIds } = props

  const cols = [
    {
      field: "oid",
      headerName: "OID",
      renderCell: (row: EntityRow) => <div>{row.oid}</div>,
      flex: 2,
    },
    {
      field: "otp",
      headerName: "OTP",
      renderCell: (row: EntityRow) => <div>{row.otp}</div>,
      flex: 1,
    },
    {
      field: "isReserved",
      headerName: "is Reserved",
      renderCell: (row: EntityRow) => (
        <div>{row.isReserved ? getDoneIcon() : getEmptyIcon()}</div>
      ),
      flex: 1,
    },
    {
      field: "isUsed",
      headerName: "is Used",
      renderCell: (row: EntityRow) => (
        <div>{row.isUsed ? getDoneIcon() : getEmptyIcon()}</div>
      ),
      flex: 1,
    },
    {
      field: "reservationDate",
      headerName: "Reservation date",
      renderCell: (row: EntityRow) => (
        <div>{getNiceFormattedDate(String(row.reservationDate))}</div>
      ),
      sortComparator: dateStringComparator,
      flex: 1,
    },
    {
      field: "expirationDate",
      headerName: "Expiration date",
      renderCell: (row: EntityRow) => (
        <div>{getNiceFormattedDate(String(row.expireDate))}</div>
      ),
      sortComparator: dateStringComparator,
      flex: 1,
    },
  ]

  const rows: EntityRow[] = objectIds.map((oid: ObjectIds) => ({
    id: oid.oid,
    oid: oid.oid,
    otp: oid.otp,
    isReserved: oid.isReserved,
    isUsed: oid.isUsed,
    reservationDate: oid.reservationDate,
    expireDate: oid.expireDate,
  }))

  return <EntityTab rows={rows} cols={cols} isLoading={false} />
}
